import { Card } from "../../Card";
import Button from "../../button/Button";
import clsx from "clsx";
import { BiChevronDown } from "react-icons/bi";
import { Loader } from "../../loader/Loader";
import { FilterDropdown } from "../../filterDropdown";
import { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "sonner";
import { getInitials } from "../../../utils";
import dayjs from "dayjs";

const filters = [
  {
    key: "All Time",
    value: "alltime",
  },
  {
    key: "Monthly",
    value: "monthly",
  },
  {
    key: "Weekly",
    value: "weekly",
  },
  {
    key: "Daily",
    value: "daily",
  },
];

export const Referrals = ({ isLoading, referrals }) => {
  const [type, setType] = useState(filters[0]);
  return (
    <>
      <div className="mb-5 flex items-center justify-between gap-5 ">
        <h3 className="text-xl font-bold text-black">Referrals</h3>
        <div className="flex items-center gap-3">
          <p className="text-sm font-medium text-[#00000080]">Filters:</p>
          <FilterDropdown
            options={filters}
            selectedOption={type}
            setSelectedOption={setType}
            selectedOptionClass={clsx(
              "rmc_select_selected !rounded-none",
              type?.value ? "bg-[#2741d6] !text-white" : "",
            )}
            selectedClass="bg-white !text-black"
            dropdownClass="rmc_select_dropdown text-xs !bg-white"
            optionsClass="rmc_select_options !text-black hover:bg-[#2741d6] hover:!text-[#ffff]"
            trailingIcon={
              <BiChevronDown
                size={16}
                className="text-[#0000004D] transition-transform duration-200"
              />
            }
          />
        </div>
      </div>

      <Card className="flex flex-col gap-5">
        {isLoading ? (
          <div className="h-[40dvh] flex items-center justify-center">
            <Loader type="spinningBubbles" color="#386be4d4" />
          </div>
        ) : referrals?.data?.length === 0 ? (
          <div className="flex flex-col justify-center items-center p-5">
            <p className="text-base text-center text-primary-black font-semibold mb-5">
              No referrals yet
            </p>
            <CopyToClipboard
              text={"https://arenaworld.fun/"}
              onCopy={() => {
                toast.success("Copied");
              }}
            >
              <Button
                text="Share Link"
                className={clsx("!shadow-none p-2.5 !text-sm")}
              />
            </CopyToClipboard>
          </div>
        ) : (
          referrals?.data?.map((x, i) => {
            const initials = getInitials(x.first_name, x.last_name);

            const getDisplayName = () => {
              const firstName = x?.first_name?.trim();
              const lastName = x?.last_name?.trim();
              const hasName = firstName || lastName;

              return hasName
                ? `${firstName || ""} ${lastName || ""}`.trim()
                : "Anonymous";
            };
            const displayName = getDisplayName();
            return (
              <div className="flex items-center  justify-between" key={i}>
                <div className="flex items-center gap-2.5 880:gap-4">
                  <div className="flex items-center justify-center py-3 px-3 text-primary-main text-sm rounded-md bg-[#ECEFFF]">
                    {initials}
                  </div>
                  <div>
                    <p className="880:ml-8 font-medium text-sm leading-tight text-[#000000]">
                      {displayName}
                    </p>
                    <p className="font-medium text-xs leading-tight text-[#0000004D]">
                      {dayjs(x.created_at).format("MMM D, YYYY")}
                    </p>
                  </div>
                </div>
                <p
                  className={clsx("text-primary-main font-semibold text-base")}
                >
                  {x.points ?? null}
                </p>
              </div>
            );
          })
        )}
      </Card>
    </>
  );
};
